import { render, staticRenderFns } from "./addcommercial_pzxx.vue?vue&type=template&id=54a45bc4&scoped=true&"
import script from "./addcommercial_pzxx.vue?vue&type=script&lang=js&"
export * from "./addcommercial_pzxx.vue?vue&type=script&lang=js&"
import style0 from "./addcommercial_pzxx.vue?vue&type=style&index=0&id=54a45bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a45bc4",
  null
  
)

export default component.exports